import { render, staticRenderFns } from "./ListIncidencias.vue?vue&type=template&id=0b7f7748&"
import script from "./ListIncidencias.vue?vue&type=script&lang=js&"
export * from "./ListIncidencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports